import { Bowed } from 'components/curves'
import { CONFIG, FREE_SHIPPING_THRESHOLD } from 'shared/constants'
import { numberToCurrency } from 'lib/money'
import css from './hero.scss'

const StoreHero = () => (
  <div
    aria-label={`Discover the best baby gear tested by our experts and real parents. Free shipping over ${numberToCurrency(
      FREE_SHIPPING_THRESHOLD,
      { truncateZeroCents: true, unit: '$' }
    )}*. ${CONFIG.store?.registryDiscountPctDisplay} registry discount.**`}
    className={css.storeHero}
  >
    <Bowed position="bottom" />
  </div>
)

export default StoreHero
